<template>
  <div class="card">
    <div class="card-header padding_12_20">
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center">
          <div class="me-3">
            <img src="@/assets/images/svg-img/distribution.svg" />
          </div>
          <div>
            <div class="card_title_1">DISTRIBUTION</div>
            <div class="card_title_2">Last Updated {{ last_update }}</div>
          </div>
        </div>
        <div>
          <span
            class="text-detail m-r-25"
            :class="{ 'area-tab-selected': selectedTab === 'reg_opdis' }"
            @click="selectTab('reg_opdis')"
          >
            All
          </span>
          <span
            class="text-detail m-r-25"
            :class="{ 'area-tab-selected': selectedTab === 'reg_opdis_sumkal' }"
            @click="selectTab('reg_opdis_sumkal')"
          >
            Sumatera & Kalimantan
          </span>
          <span
            class="text-detail m-r-25"
            :class="{ 'area-tab-selected': selectedTab === 'reg_opdis_jamali' }"
            @click="selectTab('reg_opdis_jamali')"
          >
            Jawa, Madura & Bali
          </span>
          <span
            class="text-detail"
            :class="{
              'area-tab-selected': selectedTab === 'reg_opdis_sulmapana',
            }"
            @click="selectTab('reg_opdis_sulmapana')"
          >
            Sulawesi, Papua, Maluku & Nusa Tenggara
          </span>
        </div>
      </div>
    </div>

    <div class="card-body">
      <div class="row mb-4">
        <div class="col-md-4">
          <h5 class="mx-0 mb-4 sub_title_1">EFFICIENCY</h5>
          <div class="row">
            <div class="col-md-6" style="padding: 0 4px">
              <CardWhite
                v-if="
                  distribution != null && distribution.efficiency[0] != null
                "
                :param="distribution.efficiency[0]"
                :height="150"
                :selected="selectedCard === distribution.efficiency[0].metricId"
                @click="selectCard(distribution.efficiency[0])"
              ></CardWhite>
              <card-white-null v-else :height="150"></card-white-null>
              <CardWhite
                v-if="
                  distribution != null && distribution.efficiency[1] != null
                "
                :param="distribution.efficiency[1]"
                :height="150"
                :selected="selectedCard === distribution.efficiency[1].metricId"
                @click="selectCard(distribution.efficiency[1])"
              ></CardWhite>
              <card-white-null v-else :height="150"></card-white-null>
            </div>
            <div class="col-md-6" style="padding: 0 4px">
              <CardWhite
                v-if="
                  distribution != null && distribution.efficiency[2] != null
                "
                :param="distribution.efficiency[2]"
                :height="150"
                :selected="selectedCard === distribution.efficiency[2].metricId"
                @click="selectCard(distribution.efficiency[2])"
              ></CardWhite>
              <card-white-null v-else :height="150"></card-white-null>
              <CardWhite
                v-if="
                  distribution != null && distribution.efficiency[3] != null
                "
                :param="distribution.efficiency[3]"
                :height="150"
                :selected="selectedCard === distribution.efficiency[3].metricId"
                @click="selectCard(distribution.efficiency[3])"
              ></CardWhite>
              <card-white-null v-else :height="150"></card-white-null>
            </div>
          </div>
        </div>
        <div class="col-md-2">
          <h5 class="mx-0 mb-4 sub_title_1">QUALITY</h5>

          <CardWhite
            v-if="distribution != null && distribution.quality[0] != null"
            :param="distribution.quality[0]"
            :height="150"
            :selected="selectedCard === distribution.quality[0].metricId"
            @click="selectCard(distribution.quality[0])"
          ></CardWhite>
          <card-white-null v-else :height="150"></card-white-null>
          <CardWhite
            v-if="distribution != null && distribution.quality[1] != null"
            :param="distribution.quality[1]"
            :height="150"
            :selected="selectedCard === distribution.quality[1].metricId"
            @click="selectCard(distribution.quality[1])"
          ></CardWhite>
          <card-white-null v-else :height="150"></card-white-null>
        </div>
        <div class="col-md-6">
          <h5 class="mx-0 mb-4 sub_title_1">RELIABILITY</h5>
          <div class="row">
            <div class="col-3" style="padding: 0 4px">
              <CardWhite
                v-if="distribution != null && distribution.realibity[0] != null"
                :param="distribution.realibity[0]"
                :height="308"
                :selected="selectedCard === distribution.realibity[0].metricId"
                @click="selectCard(distribution.realibity[0])"
              ></CardWhite>
              <card-white-null v-else :height="150"></card-white-null>
            </div>
            <div class="col-3" style="padding: 0 4px">
              <CardWhite
                v-if="distribution != null && distribution.realibity[1] != null"
                :param="distribution.realibity[1]"
                :height="308"
                :selected="selectedCard === distribution.realibity[1].metricId"
                @click="selectCard(distribution.realibity[1])"
              ></CardWhite>
              <card-white-null v-else :height="150"></card-white-null>
            </div>
            <div class="col-3" style="padding: 0 4px">
              <CardWhite
                v-if="distribution != null && distribution.realibity[2] != null"
                :param="distribution.realibity[2]"
                :height="308"
                :selected="selectedCard === distribution.realibity[2].metricId"
                @click="selectCard(distribution.realibity[2])"
              ></CardWhite>
              <card-white-null v-else :height="150"></card-white-null>
            </div>
            <div class="col-3" style="padding: 0 4px">
              <CardWhite
                v-if="distribution != null && distribution.realibity[3] != null"
                :param="distribution.realibity[3]"
                :height="150"
                :selected="selectedCard === distribution.realibity[3].metricId"
                @click="selectCard(distribution.realibity[3])"
              ></CardWhite>
              <card-white-null v-else :height="150"></card-white-null>
              <CardWhite
                v-if="distribution != null && distribution.realibity[4] != null"
                :param="distribution.realibity[4]"
                :height="150"
                :selected="selectedCard === distribution.realibity[4].metricId"
                @click="selectCard(distribution.realibity[4])"
              ></CardWhite>
              <card-white-null v-else :height="150"></card-white-null>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-10">
          <div class="header-top m-t-5 m-b-20">
            <h5 class="m-0">{{ titleDetail }}</h5>
            <div style="display: flex; gap: 20px">
              <div class="card-header-right-icon">
                <span class="badge badge-light text-dark"
                  >Total Units (selected region): 22</span
                >
                <span class="badge badge-light text-dark">
                  Status:
                  <img
                    height="16"
                    src="@/assets/images/svg-icon/badge-checkcircle-red.svg"
                  />
                  Below Target (5)
                  <img
                    height="16"
                    src="@/assets/images/svg-icon/badge-checkcircle-blue.svg"
                  />
                  Above Target (16)
                  <img
                    height="16"
                    src="@/assets/images/svg-icon/badge-region-red.svg"
                  />
                  Region Below Target (1)
                  <img
                    height="16"
                    src="@/assets/images/svg-icon/badge-region-green.svg"
                  />
                  Region Above Target (2)
                </span>
              </div>
            </div>
          </div>
          <div>
            <l-map
              :zoom="simple.zoom"
              :center="simple.center"
              :options="simple"
              :zoomControl="false"
              :dragging="false"
              style="height: 624px; z-index: 0"
            >
              <l-tile-layer :url="simple.url"></l-tile-layer>
              <l-marker
                v-for="(marker, index) in distributionMap.sumkal"
                :lat-lng="[marker.latitude, marker.longitude]"
                :icon="simple.iconBlue"
                @click="clickMarker(marker)"
                ><l-tooltip>
                  {{ marker.instanceName }}
                  <br />
                  <div v-for="metric in marker.metrics">
                    {{ metric.name }} ({{ metric.unit }})
                    <br />
                    {{ formattedNumber(metric.value) }}
                  </div>
                </l-tooltip>
              </l-marker>
              <l-marker
                v-for="(marker, index) in distributionMap.jamali"
                :lat-lng="[marker.latitude, marker.longitude]"
                :icon="simple.iconBlue"
                @click="clickMarker(marker)"
                ><l-tooltip>
                  {{ marker.instanceName }}
                  <br />
                  <div v-for="metric in marker.metrics">
                    {{ metric.name }} ({{ metric.unit }})
                    <br />
                    {{ formattedNumber(metric.value) }}
                  </div>
                </l-tooltip>
              </l-marker>
              <l-marker
                v-for="(marker, index) in distributionMap.sulmapana"
                :lat-lng="[marker.latitude, marker.longitude]"
                :icon="simple.iconBlue"
                @click="clickMarker(marker)"
                ><l-tooltip>
                  {{ marker.instanceName }}
                  <br />
                  <div v-for="metric in marker.metrics">
                    {{ metric.name }} ({{ metric.unit }})
                    <br />
                    {{ formattedNumber(metric.value) }}
                  </div>
                </l-tooltip>
              </l-marker>
            </l-map>
          </div>
        </div>
        <div class="col-2" style="padding: 0 4px">
          <h5 class="mx-0 mb-4 sub_title_1">SAFETY</h5>

          <CardWhite
            v-if="distribution != null && distribution.safety[0] != null"
            :param="distribution.safety[0]"
            :height="120"
            :selected="selectedCard === distribution.safety[0].metricId"
            @click="selectCard(distribution.safety[0])"
          ></CardWhite>
          <card-white-null v-else :height="150"></card-white-null>
          <CardWhite
            v-if="distribution != null && distribution.safety[1] != null"
            :param="distribution.safety[1]"
            :height="120"
            :selected="selectedCard === distribution.safety[1].metricId"
            @click="selectCard(distribution.safety[1])"
          ></CardWhite>
          <card-white-null v-else :height="150"></card-white-null>
          <CardWhite
            v-if="distribution != null && distribution.safety[2] != null"
            :param="distribution.safety[2]"
            :height="120"
            :selected="selectedCard === distribution.safety[2].metricId"
            @click="selectCard(distribution.safety[2])"
          ></CardWhite>
          <card-white-null v-else :height="150"></card-white-null>
          <CardWhite
            v-if="distribution != null && distribution.safety[3] != null"
            :param="distribution.safety[3]"
            :height="120"
            :selected="selectedCard === distribution.safety[3].metricId"
            @click="selectCard(distribution.safety[3])"
          ></CardWhite>
          <card-white-null v-else :height="150"></card-white-null>
          <CardWhite
            v-if="distribution != null && distribution.safety[4] != null"
            :param="distribution.safety[4]"
            :height="120"
            :selected="selectedCard === distribution.safety[4].metricId"
            @click="selectCard(distribution.safety[4])"
          ></CardWhite>
          <card-white-null v-else :height="150"></card-white-null>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconSvg from "@/components/IconSvg.vue";
import {
  LMap,
  LTileLayer,
  LMarker,
  LIcon,
  LTooltip,
} from "@vue-leaflet/vue-leaflet";
import { latLng, icon } from "leaflet";

import DistributionService from "@/services/distribution/distribution";
const apiDistribution = DistributionService.build();

import CardWhite from "./CardWhite.vue";
import { formattedNumber } from "@/utils/helper";
import CardWhiteNull from "./CardWhiteNull.vue";
import "leaflet/dist/leaflet.css";

export default {
  components: {
    IconSvg,
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    LTooltip,
    CardWhite,
    CardWhiteNull,
  },
  data() {
    return {
      dataMap: [],
      titleMap: "",
      simple: {
        zoomControl: false,
        dragging: false,
        doubleClickZoom: false,
        scrollWheelZoom: false,
        zoom: 5,
        minZoom: 3,
        maxZoom: 18,
        center: [-1.8263233, 118.3522204],
        url: "http://{s}.tile.osm.org/{z}/{x}/{y}.png",
        iconBlue: icon({
          iconUrl: "map-marker-circle-blue.svg",
          iconSize: [16, 16],
          iconAnchor: [8, 8],
        }),
        iconRed: icon({
          iconUrl: "map-marker-circle-red.svg",
          iconSize: [16, 16],
          iconAnchor: [8, 8],
        }),
      },
      last_update: "1 month ago",
      cities: "all",

      distribution: null,
      distributionMap: [],
      selectedTab: "reg_opdis",
      selectedCard: 0,
      modalMap: {
        show: false,
        load: false,
      },
      titleDetail: "",
    };
  },
  created() {
    this.getDataDistribution("reg_opdis");
    // this.getDataDistributionMap();
  },
  methods: {
    onCloseModalMap(value) {
      this.modalMap.show = value;
    },
    clickMarker(x) {
      this.modalMap.show = true;
      this.dataMap = x;
    },
    selectTab(tab) {
      this.getDataDistribution(tab);
      this.selectedTab = tab;
    },

    selectCard(id) {
      this.selectedCard = id.metricId;
      this.titleDetail = id.metricName + " " + `(${id.unit})`;
      this.getDataDistributionMap(id.metricId);
    },

    async getDataDistribution(instance) {
      let param = Object.assign({
        instance: instance,
      });
      const res = await apiDistribution.getDataDistribution(param);
      if (res && res.status == 200) {
        const datas = res.data.data.efficiency[0];
        this.selectCard(datas);
        this.titleDetail = datas.metricName + " " + `(${datas.unit})`;
        this.distribution = res.data.data;
      }
    },

    async getDataDistributionMap(id) {
      let param = Object.assign({
        metricId: id,
      });
      const res = await apiDistribution.getDataDistributionMap(param);
      if (res && res.status == 200) {
        this.distributionMap = res.data.data;
      }
    },
    formattedNumber,
  },
};
</script>

<style scoped>
.area-tab-selected {
  padding: 5px 10px;
  border-radius: 8px;
  background-color: #00a3e9;
  color: #fff;
}

.sub_title_3 {
  font-size: 12px;
  font-weight: 400;
  line-height: 14.06px;
  letter-spacing: 0.02em;
  text-align: left;
}

.data_text_2 {
  font-size: 20px;
  font-weight: 700;
  line-height: 24.2px;
  text-align: left;
}
</style>
